export enum Severity {
  Error = 'error',
  Warning = 'warning',
  Off = 'off',
}
